import * as UI from "@iyk/ui"

import { Icon } from "@iyk/ui"
import { appConfig } from "../../app-config.ts"
import { BackToProfileButton } from "./back-to-profile-button.tsx"
import { Link, Routes } from "./link.tsx"
import { UserProfile } from "./user-profile.tsx"
import { FanLayout } from "../../ui/fan-layout.tsx"

export const EmptyCollection = ({ name }: { name: string }) => {
  return (
    <FanLayout
      header={
        <header className="text-gray-12 w-full h-[var(--header-height)] z-30 p-4 flex items-center">
          <Link to={Routes.home}>
            <img
              src={appConfig.assets.images.logo.url}
              style={{ width: `${appConfig.assets.images.logo.width}px` }}
              alt={`${appConfig.artist.name} logo`}
            />
          </Link>
        </header>
      }
    >
      <div className="px-4 flex flex-col grow">
        <BackToProfileButton />
        <div className="flex-1 content-center flex flex-col justify-between">
          <div className="flex-1 flex flex-col items-center justify-center gap-3">
            <span className="text-sm text-white">Nothing collected yet</span>
            <span className="text-sm text-gray-11 max-w-40 text-center">Claim items to get started</span>
            {appConfig.shopUrl && (
              <div className="flex gap-2 mt-1">
                <a
                  href={appConfig.shopUrl}
                  target="_blank"
                  rel="noreferrer"
                  className={UI.classForButton({
                    kind: "outline",
                    size: "sm",
                    className: "px-2"
                  })}
                >
                  Shop items <Icon.ArrowUpRight />
                </a>
              </div>
            )}
          </div>
          <span className="text-white py-24">
            <UserProfile name={name} />
          </span>
        </div>
      </div>
    </FanLayout>
  )
}
